import styled from 'styled-components';
import { Icon as SemanticIcon } from 'semantic-ui-react';
import TextareaAutosize from 'react-autosize-textarea';

import { Text as TextLayoutComponent, PolymorphicContainer } from '@playbookux/playbook-web-core';

const Text = styled(TextLayoutComponent)`
  display: block;
  font-weight: 400;
`;

const ContainerTranscript = styled.span`
  margin-bottom: 10px;
`;

const Container = styled(PolymorphicContainer)``;

const Speaker = styled(TextLayoutComponent.Bold).attrs(() => ({
  unselectable: false,
}))`
  display: block;
  width: 125px;
`;

const TimeLink = styled.a``;

const Field = styled(TextareaAutosize)`
  color: #4D5473;
  background: #fff;
  padding: 0%;
  border: 0;
  width: 100%;
  resize: none;
  overflow-y: scroll;
  :focus {
    border: 0;
  }
  :before {
    content: "...";
    font: "Roboto";
    font-size: 23pt;
    color: #5E6C84;
    float: right;
  }
`;

const Edit = styled.a`
  user-select: none;
`;

const Icon = styled(SemanticIcon)`
  cursor: pointer;
`;

export {
  Container,
  ContainerTranscript,
  Edit,
  Field,
  Icon,
  Speaker,
  Text,
  TimeLink,
};
